document.addEventListener('DOMContentLoaded', () => {
    (document.querySelectorAll('.productChooseButton, .compareProductListCheckbox') as NodeListOf<HTMLElement>).forEach((element) => {
        element.addEventListener('click', (event) => {
            event.stopPropagation();
            if (!(event.target as HTMLElement).matches('.compareProductListCheckbox')) {
                // Do not prevent default if the checkbox itself was clicked, to trigger the checkbox state change, but prevent default for other clicks, e.g. the button
                event.preventDefault();
            }
            const checkbox = element.querySelector('.compareProductListCheckbox') as HTMLInputElement
            if (checkbox) {
                checkbox.checked = !checkbox.checked;
            }

            // Find all checked checkboxes and update the watchlist cookie
            const checkedProducts: string[] = [];
            document.querySelectorAll('.compareProductListCheckbox:checked').forEach(element => {
                checkedProducts.push((element as HTMLInputElement).id.split('puid')[1])
            })
            document.cookie = 'watchlist=' + checkedProducts.join(',') + '; path=/';
        })
    })

    // Parse cookies to find watchlist and check corresponding checkboxes
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());
    const watchlistCookie = cookies.find(cookie => cookie.startsWith('watchlist='));
    if (watchlistCookie) {
        const watchlistValue = watchlistCookie.split('=')[1];
        const productIds = watchlistValue.split(',');
        productIds.forEach(productId => {
            const checkbox = document.getElementById(`compareProductList-puid${productId}`) as HTMLInputElement;
            if (checkbox) {
                checkbox.checked = true;
            }
        });
    }
})
